import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsDateTimePickerModule } from '../../common/component/datetime-picker';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { CalendarNavigationComponent } from './calendar-navigation/calendar-navigation.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ScheduleEventContainerComponent } from './schedule-event/schedule-event.container.component';
import { ScheduleEventSelectEventDialogComponent } from './schedule-event/select-event-dialog.component';
import { SelectOptionCalendarComponent } from './select-option-calendar/select-option-calendar.component';
import { ScheduleService } from './services/schedule.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        CmpsCommonModule,
        NgbModule,
        SelectModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        CmpsLazyI18nModule,
        CmpsDateTimePickerModule,
        CmpsIconModule,
        CmpsDialogModule,
        CmpsButtonModule,
    ],
    declarations: [
        CalendarComponent,
        CalendarNavigationComponent,
        ScheduleEventSelectEventDialogComponent,
        ScheduleEventContainerComponent,
        SelectOptionCalendarComponent,
    ],
})
export class CmpsScheduleModule {
    static forRoot(): ModuleWithProviders<CmpsScheduleModule> {
        return {
            ngModule: CmpsScheduleModule,
            providers: [ScheduleService],
        };
    }
}
